import React from 'react'
import { Modal, Button, Typography, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

interface ProductDeleteConfirmationModalProps {
	open: boolean
	onClose: () => void
	onDelete: () => void
	productName: string
}

export const ProductDeleteConfirmationModal: React.FC<
	ProductDeleteConfirmationModalProps
> = ({ open, onClose, onDelete, productName }) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="delete-confirmation-title"
			aria-describedby="delete-confirmation-description"
		>
			<Box component="div" sx={styles.modalContent}>
				<IconButton onClick={onClose} sx={styles.closeButton} aria-label="close">
					<CloseIcon />
				</IconButton>
				<DeleteOutlineIcon sx={styles.icon} />
				<Typography
					id="delete-confirmation-title"
					variant="h6"
					component="h2"
					sx={styles.title}
				>
					제품 삭제 확인
				</Typography>
				<Typography
					id="delete-confirmation-description"
					variant="body1"
					sx={styles.description}
				>
					정말로 <strong>{productName}</strong>을(를) 삭제하시겠습니까?
				</Typography>
				<Typography variant="body2" color="text.secondary" sx={styles.warning}>
					이 작업은 되돌릴 수 없습니다.
				</Typography>
				<Box sx={styles.buttonContainer}>
					<Button variant="outlined" onClick={onClose} sx={styles.cancelButton}>
						취소
					</Button>
					<Button
						variant="contained"
						color="error"
						onClick={onDelete}
						sx={styles.deleteButton}
					>
						삭제하기
					</Button>
				</Box>
			</Box>
		</Modal>
	)
}

const styles = {
	modalContent: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '400px',
		backgroundColor: 'white',
		boxShadow:
			'0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
		padding: '32px',
		borderRadius: '8px',
		textAlign: 'center',
	},
	closeButton: {
		position: 'absolute',
		right: '8px',
		top: '8px',
	},
	icon: {
		fontSize: '48px',
		color: '#f44336',
		marginBottom: '16px',
	},
	title: {
		marginBottom: '16px',
	},
	description: {
		marginBottom: '8px',
	},
	warning: {
		marginBottom: '24px',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'center',
		gap: '16px',
	},
	cancelButton: {
		minWidth: '100px',
	},
	deleteButton: {
		minWidth: '100px',
	},
}
